export default "__VITE_ASSET__CULoG1jA__"